import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/lib/index.ts';

import { LazyHome } from '@confluence/home/entry-points/LazyHome.ts';
import { LazyForYou } from '@confluence/home/entry-points/LazyForYou.ts';
import { GoToHomeLoader } from '@confluence/home-redirects/entry-points/GoToHome.ts';
import { SiteHomepageRedirectLoader } from '@confluence/home-redirects/entry-points/SiteHomepageRedirect.ts';

export const preloadHome = ({ name, params }) => {
	getEditorPreloader();
	GoToHomeLoader.preload();

	if (name === 'WIKI') {
		SiteHomepageRedirectLoader.preload();
	}

	LazyHome.preload();

	if (params.view === 'undefined' || typeof params.view === 'undefined' || name === 'WIKI') {
		LazyForYou.preload();
	}
};
